"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = void 0;

/* eslint-disable import/prefer-default-export */
var assert = function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion failed';

  if (!condition) {
    if (typeof Error !== 'undefined') {
      throw new Error(message);
    }

    throw message; // fallback if Error not supported
  }
};

exports.assert = assert;